import { Box, Stack, Typography, Divider, Skeleton } from "@mui/material";

const ClientSummary = ({ totalActiveMembers, totalPolicyCount, totalApplicantCount, loading }) => {
	const hasData = totalActiveMembers != null && totalPolicyCount != null && totalApplicantCount != null;

	if (loading) {
		return (
			<Box
				sx={{
					flex: 1,
					p: "16px 18px",
					backgroundColor: "background.paper",
					border: "1px solid rgba(29,84,162,0.1)",
					borderRadius: "12px",
					boxShadow: "0 1px 8px rgba(29,84,162,0.06)",
				}}
			>
				<Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1, mb: 0.5 }}>
					<Box sx={{ gridColumn: "span 2", backgroundColor: "background.default", borderRadius: 1.5, p: "10px 12px" }}>
						<Skeleton variant="text" width="40%" height={14} />
						<Skeleton variant="text" width="30%" height={24} />
					</Box>
					<Box sx={{ backgroundColor: "background.default", borderRadius: 1.5, p: "10px 12px" }}>
						<Skeleton variant="text" width="60%" height={14} />
						<Skeleton variant="text" width="40%" height={24} />
					</Box>
					<Box sx={{ backgroundColor: "background.default", borderRadius: 1.5, p: "10px 12px" }}>
						<Skeleton variant="text" width="60%" height={14} />
						<Skeleton variant="text" width="40%" height={24} />
					</Box>
				</Box>
				<Divider sx={{ my: 1.25 }} />
				<Stack direction="row" justifyContent="space-between" py={0.6}>
					<Skeleton variant="text" width="50%" height={16} />
					<Skeleton variant="text" width="15%" height={16} />
				</Stack>
				<Stack direction="row" justifyContent="space-between" py={0.6}>
					<Skeleton variant="text" width="40%" height={16} />
					<Skeleton variant="text" width="15%" height={16} />
				</Stack>
			</Box>
		);
	}

	const avgPolicies = totalActiveMembers ? (totalPolicyCount / totalActiveMembers).toFixed(2) : "0.00";
	const conversionRate =
		totalActiveMembers + totalApplicantCount ? Math.round((totalActiveMembers / (totalActiveMembers + totalApplicantCount)) * 100) : 0;

	const stats = [
		{ label: "Active members", value: totalActiveMembers, full: true },
		{ label: "Policy count", value: totalPolicyCount },
		{ label: "Applicants", value: totalApplicantCount },
	];

	return (
		<Box
			sx={{
				flex: 1,
				p: "16px 18px",
				backgroundColor: "background.paper",
				border: "1px solid rgba(29,84,162,0.1)",
				borderRadius: "12px",
				boxShadow: "0 1px 8px rgba(29,84,162,0.06)",
			}}
		>
			<Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1, mb: 0.5 }}>
				{stats.map(({ label, value, full }) => (
					<Box
						key={label}
						sx={{
							gridColumn: full ? "span 2" : "span 1",
							backgroundColor: "background.default",
							borderRadius: 1.5,
							p: "10px 12px",
						}}
					>
						<Typography
							sx={{ fontSize: "0.6rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "text.secondary", mb: 0.25 }}
						>
							{label}
						</Typography>
						<Typography sx={{ fontSize: "1.1rem", fontWeight: 500 }}>{(value ?? 0).toLocaleString()}</Typography>
					</Box>
				))}
			</Box>

			<Divider sx={{ my: 1.25 }} />

			<Stack direction="row" justifyContent="space-between" py={0.6}>
				<Typography sx={{ fontSize: "0.75rem", color: "text.secondary" }}>Avg policies / member</Typography>
				<Typography sx={{ fontSize: "0.8rem", fontWeight: 500 }}>{avgPolicies}</Typography>
			</Stack>
			<Stack direction="row" justifyContent="space-between" py={0.6}>
				<Typography sx={{ fontSize: "0.75rem", color: "text.secondary" }}>Conversion rate</Typography>
				<Typography sx={{ fontSize: "0.8rem", fontWeight: 500 }}>{conversionRate}%</Typography>
			</Stack>
		</Box>
	);
};

export default ClientSummary;
